import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-review-batch-edit',
  templateUrl: './modal-review-batch-edit.component.html',
  styles: []
})
export class ModalReviewBatchEditComponent extends ExcTranslation implements OnInit {

  input = {Comment: '', Code: null};
  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  proceed() {
    this.overlayRef.close({proceed: true, Comment: this.input.Comment, Code: this.input.Code});
  }
  ngOnInit() {
  }

}
